import { lazy } from 'react'

export default lazy(() => import('src/pages/Trips/TripUserKpis'))
